/**
 * A key decision as defined in key-decisions.json.
 * Constructor parameters are injected in KeyDecisionConfig.js.
 */
export default class KeyDecisionDefinition {
    constructor(id, chapter, arc, prefixAnswers, contentId, backgroundImageId, unlockedByContentId) {
        this._id = id;
        this._chapter = chapter;
        this._arc = arc;
        this._prefixAnswers = prefixAnswers;
        this._contentId = contentId;
        this._backgroundImageId = backgroundImageId;
        this._unlockedByContentId = unlockedByContentId;
    }

    get id() {
        return this._id;
    }

    get chapter() {
        return this._chapter;
    }

    get arc() {
        return this._arc;
    }

    get prefixAnswers() {
        return this._prefixAnswers;
    }

    get contentId() {
        return this._contentId;
    }

    get unlockedByContentId() {
        return this._unlockedByContentId;
    }

    get backgroundImageId() {
        return this._backgroundImageId;
    }

    toObject() {
        return {
            id: this._id,
            chapter: this._chapter,
            arc: this._arc,
            prefixAnswers: this._prefixAnswers,
            contentId: this._contentId,
            backgroundImageId: this._backgroundImageId,
            unlockedByContentId: this._unlockedByContentId,
        };
    }

    fromObject(obj) {
        this._id = obj.id;
        this._chapter = obj.chapter;
        this._arc = obj.arc;
        this._prefixAnswers = obj.prefixAnswers;
        this._contentId = obj.contentId;
        this._backgroundImageId = obj.backgroundImageId;
        this._unlockedByContentId = obj.unlockedByContentId;
    }
}